<template>
    <div class="search-box">
        <div class="od-search__backdrop" v-show="isSearchFocused" @click="setIsSearchFocused(false)"></div>
        <div class="header-search-close__wrapper">
            <div class="header-search-close" @click="closeMobileNav()">
                <div class="header-search-close__inner">
                    <svg width="18" height="18" class="header-search-close__icon"><use xlink:href="#svg_close-basketmodal" xmlns:xlink="https://www.w3.org/1999/xlink"></use></svg>
                    <div class="header-search-close__text">Close</div>
                </div>
            </div>
        </div>

        <div class="search-box__input-group">
            <input placeholder="z.B. Schreibtischstuhl" type="text" class="search-box__input" v-model="currentSearchString"
                   @focus="setIsSearchFocused(true)"  @keyup.enter="search()" @keyup.up="setIsSearchFocused(true)" autocomplete="off">

            <button class="search-box__button" type="submit" @click="search()">
                <svg width="17" height="17"><use xlink:href="#svg_new-search" xmlns:xlink="https://www.w3.org/1999/xlink"></use></svg>
            </button>
        </div>

        <div class="search-autocomplete" :class="{ 'search-autocomplete--active' : isSearchFocused }">
            <div class="search-autocomplete__head" @click="mobileBackToCat()"><span v-html="searchHeadlineString"></span></div>
            <div class="search-autocomplete__body" :class="{ 'search-autocomplete__body--active' : showCategorySearch }">

                <div class="search-autocomplete__body-inner" v-for="result in autocompletePrevCategories">
                    <div class="search-autocomplete__headline">{{ result.name }}</div>
                    <div class='search-autocomplete__item' v-for="cat in result.cats">
                        <a class='search-autocomplete__item-inner' :href='cat.url'>
                            <div class='search-autocomplete__img'>
                                <div class="d-none">{{ cat.details['0'].image2Path }}</div>
                                <img v-if="cat.details['0'].image2Path != null && cat.details['0'].image2Path != 'null'" :src="'/documents/' + cat.details['0'].image2Path" />
                            </div>
                            {{ cat.details['0'].name }} <i class='fa fa-chevron-right'></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="search-autocomplete__body-autocomplete" :class="{ 'search-autocomplete__body-autocomplete--active' : !showCategorySearch }">
                <div v-if="articleApiLoading" class="search-autocomplete__loading"></div>

                <div v-if="!articleApiLoading && autocompleteResult.length > 0" class="search-autocomplete__body-article">
                    <div class="search-autocomplete__headline">{{ searchArticleString }}</div>
                    <div class="search-autocomplete__article" v-for="result in autocompleteResult">
                        <a class="search-autocomplete__article-inner" :href="result.url">
                            <div class="search-autocomplete__article-image"><img :src="result.images"></div>
                            <div class="search-autocomplete__article-name"><span>{{ result.name }}</span>{{ result.price }}</div>
                        </a>
                    </div>
                </div>
                <div v-if="!articleApiLoading && autocompleteResult.length > 0" class="search-autocomplete__body-categories">
                    <div class="search-autocomplete__headline">{{ searchCategoryString }}</div>
                    <div class="search-autocomplete__categories">
                        <div class='search-autocomplete__item' v-for="result in autocompleteCategories">
                            <a class='search-autocomplete__item-inner' :href='result.url'>
                                <div class='search-autocomplete__img'>
                                    <div class="d-none">{{ result.image }}</div>
                                    <img v-if="result.image != '/documents/null'" :src="result.image" />
                                </div>
                                {{ result.name }}<i class='fa fa-chevron-right'></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div v-if="!articleApiLoading && autocompleteResult.length == 0" class="search-autocomplete__body-article">
                    {{ $translate("Froschkoenig::Template.searchNoProductsFound") }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ApiService from "ceres/app/services/ApiService";
    import UrlService from "ceres/app/services/UrlService";
    import { mapState } from "vuex";

    export default {
        props: {
            template:
                {
                    type: String,
                    default: "#vue-onedot-search"
                },
            categories:
                {
                    type: Array,
                    default: []
                },
        },
        created()
        {
            this.$options.template = this.template;
        },
        mounted(){

            this.$nextTick(() => {

                const urlParams = UrlService.getUrlParams(document.location.search);

                this.$store.commit("setItemListSearchString", urlParams.query);

                if (typeof (urlParams.query) != "undefined"){
                    this.currentSearchString = urlParams.query;
                }

                this.$store.dispatch("loadPartialNavigationTree", null, true)
                    .then(response =>
                    {
                        this.$store.commit("setNavigationTree", response);
                    });
            });
        },
        data()
        {
            return {
                currentSearchString: "",
                checkCurrentSearchString: "",
                autocompleteResult: [],
                autocompleteCategories: [],
                autocompletePrevCategories: [],
                isSearchFocused: false,
                promiseCount: 0,
                selectedAutocompleteIndex: -1,
                searchHeadlineString: "&nbsp;&nbsp;Suche nach Kategorien",
                searchCategoryString: "Ergebnisse nach Kategorien",
                searchArticleString: "Ergebnisse nach Produkten",
                showCategorySearch: true,
                articleApiLoading: true
            };
        },
        methods:
            {
                showMobileSearch(){
                    $(".header__search-inputs").addClass("header__search-inputs--mobile-open");
                },
                search() {
                    if (this.currentSearchString.length)
                    {
                        if (document.location.pathname === "/search")
                        {
                            //this.updateTitle(this.currentSearchString);
                            this.$store.dispatch("searchItems", this.currentSearchString);

                            this.selectedAutocompleteIndex = -1;
                            this.autocompleteResult = [];
                        }
                        else
                        {
                            let searchBaseURL = "/search?query=";

                            if (App.defaultLanguage !== App.language)
                            {
                                searchBaseURL = `/{{App.language}/search?query=`;
                            }

                            window.open(searchBaseURL + this.currentSearchString, "_self", false);
                        }
                    }
                    else
                    {
                        this.preventSearch = false;
                    }
                },
                showCategories(){
                    this.showCategorySearch = true;
                    this.searchHeadlineString =  "&nbsp;&nbsp;Suche nach Kategorien";

                    if(this.autocompletePrevCategories.length == 0){
                        let tmpCategories = this.categories;
                        let outputCats = {};
                        let searchBaseURL = "/Xsearch?query=";
                        let baseURL = "";
                        if (App.defaultLanguage !== App.language)
                        {
                            searchBaseURL = "/{{App.language}";
                            baseURL = "/{{App.language}/search?query=";
                        }

                        $(this.navigationTree).each(function(index, category) {
                            $(category.children).each(function(index2, category2) {
                                if (tmpCategories.indexOf("" + category2.id) != -1 || tmpCategories.indexOf(" " + category2.id) != -1){

                                    if (typeof(outputCats[category.id]) == "undefined"){
                                        outputCats[category.id] = {};
                                        outputCats[category.id]["name"] = category.details[0].name;
                                        outputCats[category.id]["url"] = category.url;
                                        outputCats[category.id]["cats"] = {};
                                        outputCats[category.id]["cats"][category2.id] = category2;
                                    }
                                    else{
                                        outputCats[category.id]["cats"][category2.id] = category2;
                                    }
                                }

                                $(category2.children).each(function(index3, category3) {
                                    if (tmpCategories.indexOf("" + category3.id) != -1 || tmpCategories.indexOf(" " + category3.id) != -1){

                                        if (typeof(outputCats[category.id]) == "undefined"){
                                            outputCats[category.id] = {};
                                            outputCats[category.id]["name"] = category.details[0].name;
                                            outputCats[category.id]["url"] = category.url;
                                            outputCats[category.id]["cats"] = {};
                                            outputCats[category.id]["cats"][category3.id] = category3;
                                        }
                                        else{
                                            outputCats[category.id]["cats"][category3.id] = category3;
                                        }
                                    }
                                });
                            });
                        });

                        this.autocompletePrevCategories = outputCats;
                    }
                },

                setIsSearchFocused(isActive){

                    if ((window.innerWidth <= 768 && isActive) || window.innerWidth >= 768 ){
                        this.isSearchFocused = isActive;
                    }

                    if (isActive){
                        $("body").addClass("search-open");

                        if(window.innerWidth <= 768){
                            $("body").addClass("mobile-search-open");
                            $(".search-autocomplete").addClass("search-autocomplete--active");
                        }

                        if(this.currentSearchString.length >= 3){
                            this.autocomplete(this.currentSearchString);
                        }
                        else{
                            this.showCategories();
                        }
                    }
                    else{
                        $("body").removeClass("search-open");
                    }
                },

                autocomplete(searchString)
                {
                    if (window.innerWidth >= 768){
                        this.searchHeadlineString =  "&nbsp;&nbsp;Suche nach Produkten";
                    }
                    else{
                        this.searchHeadlineString =  "<i class=\"fa fa-long-arrow-alt-left\"></i> Zurück zur Übersicht";
                    }
                    this.showCategorySearch = false;
                    this.articleApiLoading = true;

                    if (this.promiseCount >= Number.MAX_SAFE_INTEGER)
                    {
                        this.promiseCount = 0;
                    }

                    const promiseCount = ++this.promiseCount;
                    ApiService.get("/rest/fk24/item/search/autocomplete", {template: "Froschkoenig24::ItemList.Components.ItemSearch", query: searchString})
                        .done(response =>
                        {
                            if (this.promiseCount === promiseCount)
                            {
                                this.transformAutocomplete(response, searchString);
                                this.articleApiLoading = false;
                            }
                        });

                    this.checkCurrentSearchString = this.currentSearchString;
                },
                // transform the autocomplete result to usable object
                transformAutocomplete(data, searchString)
                {
                    this.autocompleteResult = [];
                    this.selectedAutocompleteIndex = -1;
                    this.autocompleteCategories = [];

                    let outputCatTmp = [];

                    if (data && data.documents.length)
                    {
                        for (const item of data.documents.slice(0, 8))
                        {
                            const imagesArr = this.$options.filters.itemImages(item.data.images, "urlPreview");
                            const images = this.$options.filters.itemImage(imagesArr);
                            const url = this.$options.filters.itemURL(item.data);
                            const name = this.$options.filters.itemName(item.data);
                            const price = item.data.price;

                            let displayName = name;

                            for (const split of searchString.split(" "))
                            {
                                displayName = displayName.replace(split, `<strong>{{split}</strong>`);
                            }


                            this.autocompleteResult.push({
                                images,
                                url,
                                name,
                                displayName,
                                price
                            });

                            if (typeof (item.data.defaultCategories[0]) != "undefined"){
                                if ( outputCatTmp.indexOf(item.data.defaultCategories[0].id) == -1) {
                                    outputCatTmp.push(item.data.defaultCategories[0].id);
                                }
                            }


                        }

                        // Kategorien laden
                        let outputCats = new Array ();

                        $(this.navigationTree).each(function(index, category) {
                            if (outputCatTmp.indexOf(category.id) > -1) {
                                if (typeof (outputCats[category.id]) == "undefined") {
                                    outputCats[category.id] = category;
                                }
                            }

                            $(category.children).each(function(index2, category2) {

                                if (outputCatTmp.indexOf(category2.id) > -1) {
                                    if (typeof (outputCats[category.id]) == "undefined") {
                                        outputCats[category.id] = category;
                                    }
                                    if (typeof (outputCats[category2.id]) == "undefined") {
                                        outputCats[category2.id] = category2;
                                    }
                                }

                                $(category2.children).each(function(index3, category3) {

                                    if (outputCatTmp.indexOf(category3.id) > -1) {

                                        if (typeof (outputCats[category.id]) == "undefined") {
                                            outputCats[category.id] = category;
                                        }
                                        if (typeof (outputCats[category2.id]) == "undefined") {
                                            outputCats[category2.id] = category2;
                                        }

                                        if (typeof (outputCats[category3.id]) == "undefined") {
                                            outputCats[category3.id] = category3;
                                        }
                                    }

                                    $(category3.children).each(function(index4, category4) {

                                        if (outputCatTmp.indexOf(category4.id) > -1) {
                                            if (typeof (outputCats[category.id]) == "undefined") {
                                                outputCats[category.id] = category;
                                            }
                                            if (typeof (outputCats[category2.id]) == "undefined") {
                                                outputCats[category2.id] = category2;
                                            }

                                            if (typeof (outputCats[category3.id]) == "undefined") {
                                                outputCats[category3.id] = category3;
                                            }
                                            if (typeof (outputCats[category4.id]) == "undefined") {
                                                outputCats[category4.id] = category4;
                                            }
                                        }

                                        $(category4.children).each(function(index5, category5) {

                                            if (outputCatTmp.indexOf(category5.id) > -1) {
                                                if (typeof (outputCats[category.id]) == "undefined") {
                                                    outputCats[category.id] = category;
                                                }
                                                if (typeof (outputCats[category2.id]) == "undefined") {
                                                    outputCats[category2.id] = category2;
                                                }

                                                if (typeof (outputCats[category3.id]) == "undefined") {
                                                    outputCats[category3.id] = category3;
                                                }
                                                if (typeof (outputCats[category4.id]) == "undefined") {
                                                    outputCats[category4.id] = category4;
                                                }
                                                if (typeof (outputCats[category5.id]) == "undefined") {
                                                    outputCats[category5.id] = category5;
                                                }
                                            }

                                            $(category5.children).each(function(index6, category6) {
                                                if (outputCatTmp.indexOf(category6.id) > -1) {
                                                    if (typeof (outputCats[category.id]) == "undefined") {
                                                        outputCats[category.id] = category;
                                                    }
                                                    if (typeof (outputCats[category2.id]) == "undefined") {
                                                        outputCats[category2.id] = category2;
                                                    }

                                                    if (typeof (outputCats[category3.id]) == "undefined") {
                                                        outputCats[category3.id] = category3;
                                                    }
                                                    if (typeof (outputCats[category4.id]) == "undefined") {
                                                        outputCats[category4.id] = category4;
                                                    }
                                                    if (typeof (outputCats[category5.id]) == "undefined") {
                                                        outputCats[category5.id] = category5;
                                                    }
                                                    if (typeof (outputCats[category6.id]) == "undefined") {
                                                        outputCats[category6.id] = category6;
                                                    }
                                                }
                                            });
                                        });
                                    });
                                });
                            });
                        });
                        let searchBaseURL = "/search?query=";
                        let baseURL = "";
                        if (App.defaultLanguage !== App.language)
                        {
                            searchBaseURL = "/{{App.language}/search?query=";
                            baseURL = "/{{App.language}";
                        }

                        let acCategories = {};

                        let maxArtCatCount = 18;
                        if (window.innerWidth >= 768){
                            maxArtCatCount = 16;
                        }
                        if (window.innerWidth >= 1200){
                            maxArtCatCount = 18;
                        }

                        if (outputCats.length > 0){
                            let i = 0;
                            $(outputCats).each(function(index, category) {
                                if (typeof(category) != "undefined" && i < maxArtCatCount){
                                    acCategories[category.id] = {};
                                    acCategories[category.id]["name"] = category.details[0].name;
                                    acCategories[category.id]["url"] = category.url;
                                    acCategories[category.id]["image"] = baseURL + "/documents/" + category.details[0].image2Path;

                                    i++;
                                }
                            });

                        }
                        this.autocompleteCategories = acCategories;
                    }
                },
                mobileBackToCat()
                {
                    if (window.innerWidth <= 768){
                        this.currentSearchString = "";
                        this.setIsSearchFocused(true);
                    }
                },
                keyup()
                {
                    this.selectedAutocompleteIndex--;

                    if (this.selectedAutocompleteIndex < 0)
                    {
                        this.selectedAutocompleteIndex = 0;
                    }
                },

                keydown()
                {
                    this.selectedAutocompleteIndex++;

                    if (this.selectedAutocompleteIndex > this.autocompleteResult.length - 1)
                    {
                        this.selectedAutocompleteIndex = this.autocompleteResult.length - 1;
                    }
                },
                closeMobileNav(){
                    $(".mobile-search").removeClass("mobile-search--active");
                    $("body").removeClass("search-open");
                    if(window.innerWidth <= 768){
                        $("body").removeClass("mobile-search-open");
                        $(".search-autocomplete").removeClass("search-autocomplete--active");
                    }
                }
            },

        computed:
            {
                ...mapState({
                    navigationTree: state => state.navigation.tree
                })
            },
        watch: {
            currentSearchString: function(newQuestion, oldQuestion) {
                if (newQuestion) {
                    if(this.currentSearchString.length >= 3) {
                        this.autocomplete(this.currentSearchString);
                    }
                    else{
                        this.showCategories();
                    }

                }
            }
        }
    }
</script>
